import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class ConflictError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ConflictError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    ConflictError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
